module.exports = __webpack_public_path__ + "static/media/cpu.08a604f6.svg";